import { withAuth } from './auth0-service';
import { baseApiUrl } from './config';

/**
 * Helper function to make authenticated API calls to project endpoints
 * @param {string} endpoint - The API endpoint (without base URL)
 * @param {string} operation - Description of the operation for error logging
 * @returns {Promise<Object|null>} - Returns status object or null on error
 */
async function fetchProjectData(endpoint, operation) {
  try {
    const authOptions = await withAuth({
      method: 'GET',
    });
    
    const response = await fetch(`${baseApiUrl}${endpoint}`, authOptions);
    
    if (response.ok) {
      // API returns a plain string, so get text instead of JSON
      const statusText = await response.text();
      // Remove quotes if present and return as object
      const cleanStatus = statusText.replace(/^"(.*)"$/, '$1');
      return { status: cleanStatus };
    } else if (response.status === 404) {
      // Endpoint not implemented yet - return Active to not block users
      console.warn(`${operation} endpoint not found (404) - assuming Active`);
      return { status: 'Active' };
    } else {
      console.warn(`Failed to ${operation}:`, response.status, response.statusText);
      // Fail open - assume Active to not block users
      return { status: 'Active' };
    }
  } catch (error) {
    console.error(`Error ${operation}:`, error);
    // Fail open - assume Active to not block users
    return { status: 'Active' };
  }
}

/**
 * Get the full project status details
 * @returns {Promise<Object|null>} - Returns project status object or null on error
 */
export async function getProjectStatus() {
  return await fetchProjectData('/project/status', 'get project status');
}

/**
 * Check if the project status is active
 * @returns {Promise<boolean>} - Returns true if project is active, false otherwise
 */
export async function checkProjectStatus() {
  const data = await getProjectStatus();
  return data?.status === "Active";
}
